const KEY = "dh_j_credentials";

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function setCredential(userId, password) {
  if (!userId || !password) return;
  const map = readAll();
  map[userId] = String(password);
  writeAll(map);
}

export function hasCredential(userId) {
  const map = readAll();
  return Boolean(userId && map[userId]);
}

export function checkCredential(userId, password) {
  const map = readAll();
  return Boolean(userId && password && map[userId] === String(password));
}

export function seedDemoCredentials() {
  /* Demo accounts are no longer seeded. */
}
